import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {EndpointsService} from "../../../services/endpoints.service";
import {HttpApiService} from "../../../services/http-api.service";
import {SharedService} from "../../../services/shared.service";
import {Constants} from "../../../services/constants";
import {AlertMessageComponent, AlertType} from "../../../shared/alert-message/alert-message.component";
import {DomSanitizer} from "@angular/platform-browser";
import {ModalDirective} from "ngx-bootstrap";
import {UserService} from "../../../services/user.service";

@Component({
  selector: 'app-quotation',
  templateUrl: './quotation.component.html'
})
export class QuotationComponent implements OnInit {
  isCreated = false;
  hasError = false;
  errorMessage: any;
  isUploading = false;
  file: any = {};
  dataSource;
  requestForQuoteId;
  disPlayQuote = false;
  isUpdating = false;
  @ViewChild('quotationModal') public quotationModal: ModalDirective;
  @Input() public quote: any = {};
  @Output() quoteUpdated = new EventEmitter();
  constructor(private Api: HttpApiService,
              private userService: UserService,
              private endpoints: EndpointsService,
              private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.quote = {message: '', displayId: '', requestForQuotation: {id: '', displayId: ''}, reference: ''};
  }

  createQuote(quote) {
    const self = this;
    this.isUploading = true;
    this.isUpdating = true;
    quote.requestForQuotation = {id: quote.requestForQuotation.id, displayId: quote.requestForQuotation.displayId}
    this.createQuoteHelper(quote)
      .subscribe(res => {
          AlertMessageComponent.open(AlertType.Success, 'Quotation Uploaded Successfully');
          this.quote = res;
          this.quote.requestForQuotation = quote.requestForQuotation;
          this.quote.reference = quote.reference;
          this.isUpdating = false;
          this.quoteUpdated.emit(this.quote);
        },
        error => {
          this.resetValues();
          this.hasError = true;
          this.errorMessage = error;
          this.isUpdating = false;
          AlertMessageComponent.open(AlertType.Error, 'Quotation Uploading Failure');
        })
    return false;
  }

  createQuoteHelper(quote) {
    const self = this;
    const data: any = {};
    data.data = self.file.data;
    data.fileName = self.file.name;
    quote.data = data;
    if (quote.id) {
      return this.Api.put(this.endpoints.getQuoteUrl() + '/' + quote.id, quote, true);
    } else {
      return this.Api.post(this.endpoints.getQuoteUrl(), quote, true);
    }
  }

  uploadAttachment(id) {
    const self = this;
    const data: any = {};
    data.data = self.file.data;
    data.id = id;
    data.fileName = self.file.name;
    this.isUpdating = true;
    self.Api.put(self.endpoints.getQuoteAttachmentUrl('tenantId=' + Constants.TENANT_ID()),
      data, true)
      .subscribe(res => {
          this.resetValues();
          self.isCreated = true;
        },
        error => {
          this.resetValues();
          this.hasError = true;
          this.errorMessage = error;
          this.isUpdating = false;
        });
  }

  uploadLogo(event) {
    const self = this;
    const fileReader = new FileReader();
    fileReader.onload = function (event1: any) {
      self.file.data = event1.target.result;
    };
    fileReader.readAsDataURL(event.target.files[0]);
    self.file.name = event.target.files[0].name;
  }

  resetValues() {
    this.isUploading = false;
    this.hasError = false;
    this.errorMessage = null;
    this.isCreated = false;
  }

  setSource(item) {
    this.isUpdating = true;
    this.dataSource = this.sanitizer.bypassSecurityTrustResourceUrl(item.attachmentUrl);
    setTimeout(() => {
        this.quotationModal.show();
        this.isUpdating = false;
      },
      3000
    );
  }

  deleteQuote(quote) {
    this.isUpdating = true;
    if (quote.id) {
      this.Api.delete(this.endpoints.getQuoteUrl() + '/' + quote.id, true).subscribe(response => {
        AlertMessageComponent.open(AlertType.Success, 'Quotation Deleted Successfully');
        this.hideModal();
        this.quoteUpdated.emit(null);
        this.isUpdating = false;
      }, error => {
        this.errorMessage = error;
        AlertMessageComponent.open(AlertType.Error, 'Deleting Process Failure');
        this.isUpdating = false;
      });
    }
  }

  showModal() {
    this.quotationModal.config.backdrop = false;
    this.quotationModal.show();
    this.disPlayQuote = true;
  }

  hideModal() {
    this.quotationModal.hide();
    this.disPlayQuote = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/buyer/quotation/quotation.component.ts